export default "__VITE_ASSET__lGcOGr3s__"